<template>
    <div class="agreement-container">
        <div class="title">
            <h4>{{userManaulInfo.title}}</h4>
            <span class="date">更新时间：{{userManaulInfo.ts}}</span>
        </div>
        <div class="content" v-html="userManaulInfo.content">
            <span></span>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    //
    import comnApi from '../../api/comn'
    //
    export default {
        name: 'swb-user-manual-info-show',
        desc: '用户手册-通用查看',
        props: ['manualId'],
        data: function () {
            return {
                userManaulInfo: {},
            }
        },
        created: function () {
            if(Utils.isNoB(this.manualId)) {
                MsgBox.warning("参数错误，manualId is null");
                return;
            }
            this.getUserManaulInfo();
        },
        methods: {
            getUserManaulInfo: function () {
                let self = this;
                let postData = {
                    id: this.manualId
                };
                let theLoad = MsgBox.loading();
                comnApi.getUserManualInfo(postData, function (result) {
                    theLoad.close();
                    if(result.type == "info") {
                        //
                        self.userManaulInfo = result.data || {};
                    } else {
                        MsgBox.warning(result.message);
                    }
                })
            },
        }
    }

</script>
<style>
    .agreement-container .title {
        overflow: hidden;
        position: relative;
        border-bottom: 1px dashed #ddd;
    }

    .agreement-container .title > h4 {
        height: 28px;
        line-height: 28px;
        text-align: center;
        color: #2D8CF0;
        font-size: 16px;
    }

    .agreement-container .title > .date {
        font-size: 12px;
        color: #666;
        float: right;
    }
</style>



// WEBPACK FOOTER //
// src/compo/comn/UserManualShow.vue